import React from 'react';
import { YMaps, Map } from 'react-yandex-maps';

const YMap = React.memo(({ instanceRef, onLoad, options, defaultOptions, defaultState, children }) => (
  <YMaps query={{ load: 'package.full', apikey: '1df3cd36-78ca-4ff8-be76-d4a72252e228' }}>
    <Map
      onLoad={onLoad}
      instanceRef={instanceRef}
      width="100%"
      height="100%"
      defaultState={defaultState}
      options={options}
      defaultOptions={defaultOptions}
    >
      {children}
    </Map>
  </YMaps>
));

export default YMap;



// WEBPACK FOOTER //
// ./src/components/common/YMap/ymap.js